import React from 'react';

import { DialogMessageContents, ModalDialog } from '@/components/Elements';

/**
 * ゲスト画面ようこそダイアログ プロパティ
 */
type Props = {
  // ダイアログ表示/非表示(true=表示)
  isOpen: boolean;
  // ダイアログを閉じる
  onClose: () => void;
  // ダイアログのタイトル
  title: string;
};

/**
 * ゲスト画面ようこそダイアログ
 */
export const WelcomeGuestDialog = React.memo(
  ({ isOpen, onClose, title }: Props) => (
    <ModalDialog
      isOpen={isOpen}
      title={title}
      buttons={[{ label: 'OK', onClick: onClose }]}
    >
      <DialogMessageContents> </DialogMessageContents>
    </ModalDialog>
  ),
);
